module.exports = __webpack_public_path__ + "static/media/file.3f5f4b27.svg";